export default "<div class=\"pill {{ status }}\">\n  {{ title }}\n</div>\n"